// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35fa6376","453":"915a60af","455":"7780576f","681":"b21389c8","977":"7f2ee2f4"}[chunkId] + ".chunk.js";
};